<mat-dialog-content data-test="ConfirmMessage">{{ data.textId | translate }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" data-test="ConfirmCancelButton" [mat-dialog-close]="false">
    {{ 'UI.Common.Action.Cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" data-test="ConfirmOkButton" [mat-dialog-close]="true">
    {{ 'UI.Common.Action.Confirm' | translate }}
  </button>
</mat-dialog-actions>
